function FileUploadModalController() {
  const ctrl = this;
  ctrl.$onInit = () => {
    ctrl.file = ctrl.resolve.file;
    ctrl.types = ['BEGIN', 'MIDDLE', 'END', 'INDEPENDENT'];
  };

  ctrl.ok = () => {
    ctrl.close({ $value: ctrl.type });
  };

  ctrl.cancel = () => {
    ctrl.dismiss();
  };
}

angular
  .module('segments.module')
  .controller('FileUploadModalController', FileUploadModalController);
